export function isEntityRoute(route) {
    return typeof route?.name === 'string' && /^(app\.)?entity\./.test(route.name)
}

export function findAppEntityDefinition(definitions, params) {
    return (definitions ?? []).find(definition => {
        const identity = definition.app_catalog
        return identity?.installation_key === params.installationKey && identity.module_key === params.moduleKey
    })
}

export function missingAppEntityRoute(target) {
    return {
        name: 'app-module-not-found',
        params: {
            tenantId: target.params.tenantId,
            appModulePath: target.path.split('/').slice(3).map(decodeURIComponent),
        },
        query: target.query,
        hash: target.hash,
        replace: true,
    }
}

export function entityRouteForDefinition(target, definition) {
    const identity = definition?.app_catalog
    if (!isEntityRoute(target) || target.name.startsWith('app.') || !identity?.installation_key || !identity.module_key) return target
    if (target.params?.entityType !== definition.slug) return target

    const { entityType, ...params } = target.params
    return {
        name: `app.${target.name}`,
        params: { ...params, installationKey: identity.installation_key, moduleKey: identity.module_key },
        ...(target.query ? { query: target.query } : {}),
        ...(target.hash ? { hash: target.hash } : {}),
        ...(target.state ? { state: target.state } : {}),
    }
}
